import { MailTemplate } from '@/interfaces/mailTemplate';
import { MailTemplateResource, mailTemplateResource } from '@/resources/mailTemplate.resource';
import { EntityModule } from './entity.module';

export class MailTemplateModule extends EntityModule<MailTemplate, MailTemplateResource> {}

export default new MailTemplateModule(mailTemplateResource);
